<template>
    <div class="page-wrapper">
        <v-snackbar
                v-model="notification"
                :color="notification_type"
                :timeout="5000"
                :top="true"
        >
            {{ notification_message }}
            <v-btn
                    dark
                    text
                    @click="notification = false"
            >
                Close
            </v-btn>
        </v-snackbar>

        <v-container
                fill-height
                fluid
                grid-list-xl>
            <v-layout
                    justify-center
                    wrap>
                <v-flex
                        xs12
                        md12
                >
                    <v-data-table
                            :headers="headers"
                            :items="users"
                            :server-items-length="totalItems"
                            :page.sync="page"
                            :items-per-page="itemsPerPage"
                            hide-default-footer
                            @page-count="pageCount = $event"
                            sort-by="calories"
                            class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>users</v-toolbar-title>
                                <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                ></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="blue-grey darken-4" dark class="mb-2" v-on="on">New users</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container grid-list-md>
                                                <v-layout wrap>
                                                    <v-flex xs12>
                                                        <v-text-field v-model="editedItem.first_name"
                                                                      label="First Name"
                                                                      required
                                                                      :error-messages="checkFirstName"
                                                                      @input="$v.editedItem.first_name.$touch()"
                                                                      @blur="$v.editedItem.first_name.$touch()"
                                                        >

                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field v-model="editedItem.last_name"
                                                                      required
                                                                      :error-messages="checkLastName"
                                                                      @input="$v.editedItem.last_name.$touch()"
                                                                      @blur="$v.editedItem.last_name.$touch()"
                                                                      label="Last Name">

                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field v-model="editedItem.username"
                                                                      required
                                                                      :error-messages="checkUsername"
                                                                      @input="$v.editedItem.username.$touch()"
                                                                      @blur="$v.editedItem.username.$touch()"
                                                                      label="Username">

                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12>
                                                        <v-text-field v-model="editedItem.email"
                                                                      required
                                                                      :error-messages="checkEmail"
                                                                      @input="$v.editedItem.email.$touch()"
                                                                      @blur="$v.editedItem.email.$touch()"
                                                                      label="Email Address">

                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 v-show="editedItem.id < 1">
                                                        <v-text-field v-model="editedItem.password"
                                                                      type="password"
                                                                      label="Password">
                                                        </v-text-field>
                                                    </v-flex>

                                                    <v-flex xs12>
                                                        <v-select
                                                                v-model="editedItem.groups"
                                                                :items="groups"
                                                                required
                                                                :error-messages="checkGroups"
                                                                @input="$v.editedItem.groups.$touch()"
                                                                @blur="$v.editedItem.groups.$touch()"
                                                                multiple
                                                                :menu-props="{closeOnClick:false, closeOnContentClick:false}"
                                                                chips
                                                                item-value="id"
                                                                item-text="name"
                                                                label="Permission"
                                                        ></v-select>
                                                    </v-flex>

                                                </v-layout>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.groups_t="{ item }">
                            <span v-for="g in item.groups">
                              {{ g.name }},
                            </span>
                        </template>
                        <template v-slot:item.action="{ item }" class="text-center">
                            <v-btn
                                    color="blue-grey darken-4"
                                    @click="editItem(item)"
                            >
                                <v-icon>
                                    mdi-pencil
                                </v-icon>
                            </v-btn>
                            <v-btn
                                    class="mx-2"
                                    color="blue-grey darken-4"
                                    @click="deleteItem(item)"
                            >
                                <v-icon>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                    <div class="text-center pt-2">
                        <v-pagination v-model="page" :length="pageCount"></v-pagination>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>

    </div>
</template>


<script>
    import {validationMixin} from 'vuelidate'
    import {required, maxLength, minLength, email} from 'vuelidate/lib/validators'

    export default {
        mixins: [validationMixin],

        validations: {
            editedItem: {
                first_name:{
                    required
                },
                last_name: {
                },
                username: {
                    required
                },
                email: {
                    required,
                    email
                },
                groups: {
                    required
                }
            }
        },
        components: {},
        data() {
            return {
                headers: [
                    {
                        text: 'First Name',
                        align: 'left',
                        sortable: false,
                        value: 'first_name',
                    },
                    {
                        text: 'Last Name',
                        align: 'left',
                        sortable: false,
                        value: 'last_name',
                    },
                    {
                        text: 'Username',
                        align: 'left',
                        sortable: false,
                        value: 'username',
                    },
                    {
                        text: 'Groups',
                        align: 'left',
                        sortable: false,
                        value: 'groups_t',
                    },
                    {
                        text: 'Actions',
                        align: 'center',
                        sortable: false,
                        value: 'action',
                    },
                ],
                notification_type: 'success',
                notification_message: '',
                notification: false,
                dialog: false,
                users: [],
                editedIndex: -1,
                editedItem: {
                    id: 0,
                    first_name: '',
                    last_name: '',
                    email: '',
                    groups: []
                },
                defaultItem: {
                    id: 0,
                    first_name: '',
                    last_name: '',
                    email: '',
                    groups: []
                },
                page: 1, //default load page
                pageCount: 0,
                itemsPerPage: 20, //items shown per page,
                totalItems: 0,
                groups: [
                    {
                        id: 1,
                        name: 'Admin'
                    },
                    {
                        id: 2,
                        name: 'Staff'
                    },
                  {
                    id: 3,
                    name: 'Kitchen'
                  }
                ]
            }
        },
        computed: {
            checkFirstName() {
                const errors = [];
                if (!this.$v.editedItem.first_name.$dirty) return errors;
                !this.$v.editedItem.first_name.required && errors.push('.first_name is required.');
                return errors;
            },
            checkLastName() {
                const errors = [];
                if (!this.$v.editedItem.last_name.$dirty) return errors;
                !this.$v.editedItem.last_name.required && errors.push('.last_name is required.');
                return errors;
            },
            checkUsername() {
                const errors = [];
                if (!this.$v.editedItem.username.$dirty) return errors;
                !this.$v.editedItem.username.required && errors.push('.email is required.');
                return errors;
            },
            checkEmail() {
                const errors = [];
                if (!this.$v.editedItem.email.$dirty) return errors;
                !this.$v.editedItem.email.email && errors.push('.email must be a valid email');
                !this.$v.editedItem.email.required && errors.push('.email is required.');
                return errors;
            },
            checkGroups() {
                const errors = [];
                if (!this.$v.editedItem.groups.$dirty) return errors;
                !this.$v.editedItem.groups.required && errors.push('editedItem.groups is required.');
                return errors;
            },
            formTitle() {
                return this.editedIndex === -1 ? 'New User' : 'Edit Item'
            },
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        created() {
            this.load_users(this.page);
        },
        methods: {
            load_users(page_no) {
                let offset = ( page_no - 1) * this.itemsPerPage;
                let limit = this.itemsPerPage;

                this.$http.get(
                    this.$http.defaults.baseURL + '/admin/users/?limit=' + limit + '&offset=' + offset).then((response) => {
                    this.users = response.data;
                    this.notification = false;
                    this.notification_message = '';
                    this.totalItems = (response.data.count / this.itemsPerPage);

                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            editItem(item) {
                this.editedIndex = this.users.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                const index = this.users.indexOf(item);
                if (confirm('Are you sure you want to delete this item?')) {
                    this.$http.delete(
                        this.$http.defaults.baseURL + '/admin/users/' + item.id + '/').then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Deleted';
                        this.users.splice(index, 1);

                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }
            },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }

                let is_superuser = false;
                let is_staff = false;
                let send_groups = [];
                let g_obj = '';

                this.editedItem.groups.forEach(function (o, i) {
                    if (typeof o.id !== 'undefined') {
                        g_obj = o.id;
                    } else {
                        g_obj = o;
                    }
                    send_groups.push(g_obj);
                    if (g_obj === 1) {
                        is_superuser = true;
                        is_staff = true;
                    }
                });

                let send_data = {
                    id: this.editedItem.id,
                    first_name: this.editedItem.first_name,
                    last_name: this.last_name,
                    email: this.editedItem.email,
                    username: this.editedItem.username,
                    is_superuser:is_superuser,
                    is_staff:is_staff,
                };

                if (this.editedIndex > -1) {
                    this.$http.patch(
                        this.$http.defaults.baseURL + '/admin/users/' + this.editedItem.id + '/', send_data).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        Object.assign(this.users[this.editedIndex], this.editedItem);
                        this.save_groups(send_groups, false, this.editedItem.id);

                        this.close()
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });


                } else {
                    send_data.password = this.editedItem.password;

                    this.$http.post(
                        this.$http.defaults.baseURL + '/admin/users/', send_data).then((response) => {
                        this.notification = true;
                        this.notification_message = 'Successfully Saved';
                        console.log(response.data);
                        this.users.push(response.data);
                        this.save_groups(send_groups, true, response.data.id)
                        this.close();
                    })
                        .catch((error) => {
                            this.notification = true;
                            this.notification_type = 'red darken-1';
                            this.notification_message = 'Error: Please contact administrator';
                            console.log("Error");
                            console.log(error);
                        });
                }

            },
            save_groups(groups, reload_users, user) {
                console.log(groups);
                console.log(user);
                this.$http.post(
                    this.$http.defaults.baseURL + '/admin/user-groups/', {
                        groups:groups,
                        user:user
                    }).then((response) => {
                    console.log(response);
                    this.notification = false;
                    this.notification_message = '';
                    if (reload_users === true )
                    {
                        this.load_users(this.page)
                    }

                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            }
        },
    }
</script>
